import AsyncSelect from "react-select/async";
// import axios from "axios";
import { BsChevronDown } from "react-icons/bs";
import { LiaTimesSolid } from "react-icons/lia";
import { Urls } from "../../../Urls";
import axios from "../../../Axios";

// Custom debounce wrapper
const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        return new Promise((resolve) => {
            timeout = setTimeout(() => resolve(func(...args)), delay);
        });
    };
};

const LocationAutoComplete = ({
    onChange,
    onClear,
    value = null,
    placeholder = "Search location...",
    isDisabled = false,
    className = "",
    noOptionsMessageText = "No locations found",
    width = null,
    menuHeight = 200,
    fontSize = 14,
    isClearable = true,
    customStyles = {},
    showDropdownIcon = true, // New prop to control dropdown icon visibility
}) => {
    const fetchSuggestions = async (inputValue) => {
        if (!inputValue || inputValue.length < 3) return [];

        try {
            const url = `${Urls.Locations.autoSuggest}?suggest=${inputValue}&limit=20&searchFields=new_locations`;
            const response = await axios.get(url);
            const locations = response.data?.value || [];

            return locations.map((loc) => ({
                label: loc.location_name,
                value: loc.location_name,
                full: loc,
            }));
        } catch (err) {
            console.error("Autocomplete error:", err);
            return [];
        }
    };

    const debouncedLoadOptions = debounce(fetchSuggestions, 500);

    const defaultStyles = {
        container: (base) => ({
            ...base,
            minWidth: width,
        }),
        control: (base) => ({
            ...base,
            borderRadius: 4,
            minHeight: 36,
            fontSize,
            boxShadow: "none",
            borderColor: "#ccc",
            width: "100%",
            cursor: "pointer",
        }),
        valueContainer: (base) => ({
            ...base,
            padding: "2px 8px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        }),
        input: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
            width: "100%",
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
            width: "100%",
        }),
        menuList: (base) => ({
            ...base,
            maxHeight: menuHeight,
            overflowY: "auto",
        }),
        option: (base) => ({
            ...base,
            fontSize,
            padding: "6px 10px",
        }),
        ...customStyles, // override or extend
    };

    // Conditional logic for dropdown icon and custom components
    const components = {
        IndicatorSeparator: () => null,
        DropdownIndicator: showDropdownIcon
            ? () => <BsChevronDown className="text-muted mx-3" />
            : () => null,
        ClearIndicator: () => (
            <LiaTimesSolid className="text-muted" onClick={onClear} />
        ),
    };

    return (
        <AsyncSelect
            cacheOptions
            loadOptions={debouncedLoadOptions}
            defaultOptions
            value={value}
            isDisabled={isDisabled}
            placeholder={placeholder}
            className={className}
            onChange={(selected) => onChange(selected)}
            components={components}
            noOptionsMessage={({ inputValue }) => {
                if (!inputValue || inputValue.length < 3) {
                    return "Type to search";
                }
                return noOptionsMessageText;
            }}
            isClearable={isClearable}
            styles={defaultStyles}
        />
    );
};

export default LocationAutoComplete;
